module.exports = __webpack_public_path__ + "img/paragraph-line-2.c92a2aa4.svg";